import React, {FC} from "react"
import styled from "styled-components"
import {Body} from "@irati/ui/src/Typography"
import {useRemoveBasketItemMutation} from "@irati/payrollpay/hooks"

interface ItemProps {
  imageUrl: string
  name: string
  price: number
  id: string
  onItemRemoved?: () => void
}

const Item: FC<ItemProps> = ({imageUrl, name, price, id, onItemRemoved}) => {
  const [removeBasketItem, {loading}] = useRemoveBasketItemMutation()

  const handleRemoveItem = async () => {
    try {
      await removeBasketItem({
        variables: {
          input: {
            basketItemId: id
          }
        }
      })
      if (onItemRemoved) {
        onItemRemoved()
      }
    } catch (error) {
      console.error("Error removing item:", error)
    }
  }

  return (
    <>
      <Container>
        <ImageContainer>
          <Image src={imageUrl} />
        </ImageContainer>
        <ContentContainer>
          <NameContainer>
            <Name>{name}</Name>
            <RemoveButton onClick={handleRemoveItem} disabled={loading}>
              {loading ? "Removing..." : "Remove"}
            </RemoveButton>
          </NameContainer>
          <PriceContainer>
            <Price>£{price?.toFixed(2) || 0}</Price>
            <Body>Per month</Body>
          </PriceContainer>
        </ContentContainer>
      </Container>
      <hr />
    </>
  )
}

export default Item

const Container = styled.div`
  display: flex;
`

const ImageContainer = styled.div`
  flex-basis: 25%;
`

const ContentContainer = styled.div`
  flex-basis: 75%;
  display: flex;
  flex-wrap: wrap;
`

const Image = styled.img`
  max-height: 70px;
  max-width: 70px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    max-height: 86px;
    max-width: 86px;

`}
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    max-height: 136px;
    max-width: 136px;
  `}
`

const NameContainer = styled.div`
  flex-basis: 66.67%;
`

const PriceContainer = styled.div`
  flex-basis: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  height: 100%;
`

const Name = styled(Body)`
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    font-size: 16px;
  `}
`

const Price = styled(Body)`
  font-size: 16px;
  color: ${({theme}) => theme.colors.primary1};

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    font-size: 24px;
  `}
`

const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
